module.exports = __webpack_public_path__ + "img/that-picture-1.eccd5d9a.png";